import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b51f94c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Map", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "See the wedding venue, hotels, welcome reception, brunch, climb time, and other wedding events as well as recommendations from Regina and Dan on the custom map below", -1))
const _hoisted_3 = { class: "map" }
const _hoisted_4 = ["height", "width"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", null, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("iframe", {
        src: "https://www.google.com/maps/d/u/2/embed?mid=1YlMmB8UCSdMQsX7Hqn0gzHWuJRzhv7Q&ehbc=2E312F",
        height: _ctx.mapHeight,
        width: _ctx.mapWidth
      }, null, 8, _hoisted_4)
    ])
  ]))
}